import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import "./styles/normalize.css";
import "./styles/global.css";
import { ThemeProvider } from "@mui/material/styles";
import GlobalTheme from "./styles/global.theme";

window.handleGooglePlacesAPICall = (data) => {};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <HelmetProvider>
            <ThemeProvider theme={GlobalTheme}>
                <App />
            </ThemeProvider>
        </HelmetProvider>
    </React.StrictMode>
);
